import React from 'react'
import Header from '../../../../../component/layout/LandingHeader'
import Footer from '../../../../../component/layout/Footer'


export default function PrivacyPolicies() {
    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">

                <div className="content-section section-padding">
                    <div className="container">

                        {/*Page Can be used in admin Dashboard, Copy From here*/}
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="text-wrap content-page-wrapper">
                                    <h2 className='heading fs-38 fw-700'>Privacy Policy for ClearView</h2>
                                    <div className="text-part">
                                        <p><strong>Effective Date:</strong> 1st Feb 2024</p>

                                        <h3>Introduction</h3>
                                        <p>Welcome to ClearView, a lead-gen application developed by Digital Apple. We are committed to protecting the privacy and security of our users' data. This Privacy Policy outlines our practices concerning the collection, use, and sharing of your information through the use of our Business Maturity Survey Tool.</p>
                                        <h3>Information We Collect</h3>
                                        <ul>
                                            <li><strong>Personal Information:</strong> This includes the names, email addresses, designations, and company details of our customers who use ClearView. ClearView also collects information from respondents participating in projects created on the ClearView platform. However, this data is encrypted.</li>
                                            <li><strong>User Responses:</strong> Answers to assessments, calculators, etc., created using the ClearView platform.</li>
                                            <li><strong>Technical Data:</strong>Usage details such as access times, device information, and IP addresses.</li>
                                        </ul>
                                        <h3>How We Use Your Information</h3>
                                        <ul>
                                            <li><strong>Generate Analytics:</strong> The purpose is primarily for viewing analytics such as user engagement, demographic information, user activities, and behavior patterns.</li>
                                            <li><strong>Improvement of Services:</strong> To enhance the functionality and user experience of our platform.</li>
                                            <li><strong>Communication:</strong> To respond to inquiries, send updates about our services, and provide customer support.</li>
                                        </ul>

                                        <h3>Data Sharing and Disclosure</h3>
                                        <ul>
                                            <li><strong>Third-Party Service Providers:</strong> We may share information with trusted partners who perform services on our behalf, under confidentiality agreements.However, we will not be sharing any personal data.</li>
                                            <li><strong>Compliance and Legal Obligations:</strong>  We may disclose information if required by law or to protect our rights and interests.</li>

                                        </ul>


                                        <h3>Data Security</h3>
                                        <p>We implement robust security measures to protect your data from unauthorized access, alteration, and loss. However, no internet-based service can guarantee absolute security.</p>

                                        <h3>Data Retention</h3>
                                        <p>We retain your information only as long as necessary for the purposes outlined in this policy, or as required by law.</p>

                                        <h3>Your Rights</h3>
                                        <p>You have the right to access, correct, or delete your personal information, as well as the right to restrict processing and the right to data portability. To exercise these rights, please contact us at <a href="mailto:support@clearview360@ai">support@clearview360@ai</a>.</p>

                                        <h3>Changes to This Policy</h3>
                                        <p>We may update this privacy policy from time to time. We will notify users of any significant changes and indicate the date of the latest revision.</p>

                                        <h3>Contact Information</h3>
                                        <p>For questions or concerns about our privacy practices, please contact us at <a href="mailto:support@clearview360.ai">support@clearview360.ai</a></p>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}
